<mat-card class="flex-col flex">
    <mat-card-header>
        <div mat-card-avatar class="cb-card-avatar-icon mat-mdc-header-card-avatar">
            @if (mappedItem?.contractType != LOT_CONTRACT_TYPE_ENUM.None) {
                <mat-icon class="cb-primary" title="Complete"> check_circle </mat-icon>
            }
            @if (mappedItem?.contractType == LOT_CONTRACT_TYPE_ENUM.None) {
                <mat-icon class="cb-error" title="Incomplete"> error </mat-icon>
            }
        </div>
        <mat-card-title [ngClass]="!mappedItem?.stepDesignAndBuildComplete ? 'cb-error' : ''">
            2. Contract Type
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="center-center flex-row flex">
        <mat-icon class="cb-grey cb-margin-right"> info </mat-icon>
        Contract Type needs to be selected
    </mat-card-content>
    @if (canEdit && !mappedItem.isQualified()) {
        <div>
            <mat-divider class="card-divider"></mat-divider>
        </div>
    }
    @if (canEdit && !mappedItem.isQualified()) {
        <mat-card-actions class="end-center flex-row">
            @if (canEdit && !mappedItem.isQualified()) {
                <button mat-stroked-button color="accent" (cbClick)="chooseContractType()">
                    Choose Contract Type
                </button>
            }
        </mat-card-actions>
    }
</mat-card>
